import { useSuspenseQuery } from '@tanstack/react-query';
import { tariffSummaryQueries } from '../queries/tariffSummaryQueries';
import { fetchTafiffSummary, TafiffSummary } from '../api/tariffSummaryApi';
import { useAtomValue } from 'jotai';
import {
  alertStatusTariffSummaryAtom,
  tariffSummaryPageFilterAtom,
  tariffSummaryRowsPerPageFilterAtom,
  tariffSummarySortingAtomWithStorage,
} from 'src/atoms/filters/tariff-summary';

type UseTariffSummaryProps = {
  accountRef: string | null;
};

export const useTariffSummary = ({ accountRef }: UseTariffSummaryProps) => {
  const pageSize = useAtomValue(tariffSummaryRowsPerPageFilterAtom);
  const page = useAtomValue(tariffSummaryPageFilterAtom);

  const sorting = useAtomValue(tariffSummarySortingAtomWithStorage);
  const alertStatus = useAtomValue(alertStatusTariffSummaryAtom);

  return useSuspenseQuery({
    queryKey: tariffSummaryQueries.list({
      pageSize,
      page,
      accountRef,
      sorting,
      alertStatus,
    }),
    queryFn: ({ signal }) => {
      if (accountRef === null) {
        return {
          lastUpdatedTimestamp: null,
          totalNumberOfItems: 0,
          items: [],
        } as TafiffSummary;
      }

      return fetchTafiffSummary(
        {
          accountRef,
          pageSize,
          page,
          sorting,
          alertStatus,
        },
        signal,
      );
    },
  });
};
